import { Loading, Message } from "element-ui";

// 错误的统一处理---------------------------------------------------------------------------
export function errorState(err) {
  // loadingInstance.close();
  if (String(err).indexOf("400") != -1) {
    Message.error("不能传特殊符号");
    return;
  }
  if (String(err).indexOf("600") != -1) {
    // location.href = "https://fuwu.taobao.com/ser/my_service.htm"
    // location.href = "https://oauth.taobao.com/authorize?response_type=code&client_id=12666072&redirect_uri=http%3A%2F%2Fdxe.yusms.com%2Ftblogin.do&state=leaseId%3A0%3BitemCode%3Ats-131195-1%3Bscope%3Ar1%2Cr2%2Cw1%2Cw2%3BversionNo%3A2%3Bsign%3AE312C246EF847BC54552CB5D84AAB41B%3Bouter_trade_code%3A%3Btimestamp%3A1551771643881&from_site=fuwu"
  } else {
    var e = (err + "").indexOf("timeout") > -1 ? "请求超时" : err + "";
    Message.error(e);
    return err;
  }
}
// 添加响应拦截器(对接口响应返回数据做点什么)----------------------------------------------------------------
export const useInterceptorsResponsehandle = ($axios) => {
  return (resolveCallback, rejectCallback) => {
    $axios.interceptors.response.use(
      (res) => {
        if (res.status === 200) {
          // 响应拦截器
          if (!Object.prototype.hasOwnProperty.call(res.data, "code")) {
            return Promise.resolve(res);
          }
          if (
            res.data.code == "200" ||
            res.data.code == "501" ||
            res.data.code == "1"
          ) {
            if (res.config.method == "post") {
              return Promise.resolve(res);
            } else {
              return Promise.resolve(res.data);
            }
          } else if (
            res.data.code === "0" &&
            res.data.message == "正在处理请求中,请不要重复请求"
          ) {
            return Promise.resolve(res.data);
          } else if (res.data.code === -1) {
            window.open("https://yz.yqcrm.cn/login", "_self");
          } else if (res.data.code == 10001) {
            window.open("https://yz.yqcrm.cn/login", "_self");
          } else if (res.data.code == 0) {
            if (res.config.method == "post") {
              return Promise.resolve(res);
            } else {
              return Promise.resolve(res.data);
            }
          } else if (res.data.code == -500) {
            if (res.config.method == "post") {
              return Promise.reject(res);
            } else {
              return Promise.reject(res.data.message);
            }
          } else {
            if (res.data.message) {
              Message.error(res.data.message);
            } else {
              Message.error(res.message);
            }
            resolveCallback(res);
            return Promise.resolve(res.data);
          }
        } else {
          rejectCallback(res);
          Message.error(res.statusText);
        }
      },
      function (err) {
        rejectCallback(err);
        errorState(err);
      }
    );
  };
};
